import gql from 'fraql';

import { Id } from '~/types';
import { useMosaicMutation } from '~/utils';

const UnassignProjectMutation = gql`
  mutation UnassignProject($agencyId: ID!, $projectId: ID!) {
    unassignAgencyFromProject(input: { agencyId: $agencyId, projectId: $projectId }) {
      agency {
        id
      }
    }
  }
`;

export function useUnassignProject() {
  const {
    res: { fetching },
    executeMutation,
  } = useMosaicMutation<{}, { agencyId: Id; projectId: Id }>(UnassignProjectMutation);

  return {
    unassignProject: executeMutation,
    isUnassignmentFetching: fetching,
  };
}
